module.exports = __webpack_public_path__ + "img/enlightenment-course-4.5f3b5ac7.png";